import request from '@/utils/request'

export function getUserCollection(current, size) {
    return request({
        url: `api/personalUser/UserCollection`,
        // url: "api/meeting/searchMeeting",
        method: 'post',
        // data
        data: {
            'current': current,
            'size': size,

        }
    })
}